const rootElement = document.documentElement;
const scrollButton = document.getElementById('scroll-top');

let lastScrollTop = rootElement.scrollTop;

function handleScroll() {
    const currentScrollTop = rootElement.scrollTop;

    const scrolledPastThreshold = currentScrollTop > rootElement.clientHeight;

    const isScrollingUp = currentScrollTop < lastScrollTop;

    if (isScrollingUp && scrolledPastThreshold) {
        scrollButton.classList.add('scroll-visible');
    } else {
        scrollButton.classList.remove('scroll-visible');
    }

    lastScrollTop = currentScrollTop;
}

function scrollToTop() {
    // Scroll to top logic
    rootElement.scrollTo({
        top: 0,
        behavior: 'smooth',
    });
}

if (scrollButton) {
    scrollButton.addEventListener('click', scrollToTop);
}
document.addEventListener('scroll', handleScroll);
